import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';

import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
// import MenuIcon from '@material-ui/core/Menu';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';

import Close from '@material-ui/icons/Close';

import CONSTANTS from '../utils/Constants';
import InvisibleCaptcha from './InvisibleCaptcha';
// import ReCaptcha from 'react-recaptcha'

const styles = theme => ({
	bar: {
	},
	regular: {
		minHeight: (theme.spacing.unit * 9)
	},

	// Not sure if this will pose a problem in tthe furture, but working well now...
	// Using keyed classes for multiple objects; each contains multiple styles for,
	// each FOR DIFFERENT ELEMENTS
	positive: {
		backgroundColor: CONSTANTS.COLORS.POSITIVE,
		borderColor: theme.palette.primary.contrastText,
	},
	uncertain: {
		backgroundColor: CONSTANTS.COLORS.UNCERTAIN,
		borderColor: theme.palette.primary.contrastText,
	},
	negative: {
		backgroundColor: CONSTANTS.COLORS.NEGATIVE,
		borderColor: theme.palette.primary.contrastText,
	},
	tip: {
		backgroundColor: CONSTANTS.COLORS.TIP,
		borderColor: theme.palette.primary.contrastText,
	},
	transparent: {
		backgroundColor: theme.palette.background.default,
		borderColor: CONSTANTS.COLORS.BLACK,
		color: CONSTANTS.COLORS.BLACK
	},

	gutters: {
		paddingLeft: (theme.spacing.unit * 3.5),
		paddingRight: (theme.spacing.unit * 3.5)
	},
	grow: {
		flex: 1
	},
	rightBtn: {
		marginRight: -1 * theme.spacing.unit
	},

	closeIcon: {
		borderWidth: 1,
		borderStyle: "solid",
		fontSize: "1.8rem",
	},
});

class HeaderBar extends Component {	

	// componentDidMount() {
	// }

	// componentWillUnmount() {
	// }
	//

	render() {
		let {classes, title, category, closeHandler, recaptchaHandler} = this.props;
		title = title || '';
		let action = category === 'transparent' && 'categorize_tip' || `share_${category}`;

		return (
			<AppBar position="static" className={classes.bar} elevation={0} square
				classes={{
					colorPrimary: classes[category]
				}}>


				<InvisibleCaptcha
					action={action}
					verifyCallback={recaptchaHandler}
				/>
				<Toolbar
					classes={{
						gutters: classes.gutters,
						regular: classes.regular
					}}>
					<Typography variant="h6" color="inherit" className={classes.grow}>{title}</Typography>
					<IconButton
						className={classes.rightBtn}
						aria-label="Close"
						color="inherit"
						onClick={closeHandler}
						ga-on="click"
						ga-event-category="WebApp"
						ga-event-action="Button Pressed"
						ga-event-label="Close">
						<Close className={`${classes.closeIcon} ${classes[category]}`} />
					</IconButton>
				</Toolbar>
			</AppBar>
		);
	}
}

HeaderBar.propTypes = {
	classes: PropTypes.object.isRequired,
	category: PropTypes.string.isRequired,
	closeHandler: PropTypes.func.isRequired,
	recaptchaHandler: PropTypes.func.isRequired,
	title: PropTypes.string
};

export default withStyles(styles)(HeaderBar);
